module.exports = __webpack_public_path__ + "static/media/5.c693e689.jpg";